import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import React from "react";
import LinkRouter from "../common/LinkRouter";
import { IJobRepair } from "./types";

interface IProps {
  job: IJobRepair;
}

const JobRepairBreadCrumbs: React.FC<IProps> = ({ job }) => {
  return (
    <Breadcrumbs aria-label="breadcrumb">
      <LinkRouter underline="hover" color="inherit" to={`/jobs/${job?.id}`}>
        Job
      </LinkRouter>
      <LinkRouter
        underline="hover"
        color="inherit"
        to={`/jobs/${job?.id}/repairs`}
      >
        Job Repairs
      </LinkRouter>
      <Typography color="text.primary">Repair</Typography>
    </Breadcrumbs>
  );
};

export default JobRepairBreadCrumbs;
